import { render, staticRenderFns } from "./feed-item.vue?vue&type=template&id=8be26152&scoped=true&"
import script from "./feed-item.vue?vue&type=script&lang=js&"
export * from "./feed-item.vue?vue&type=script&lang=js&"
import style0 from "./feed-item.vue?vue&type=style&index=0&id=8be26152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be26152",
  null
  
)

export default component.exports